const isTypeOf = (x: unknown) => (type: unknown) => typeof type === x;

export const isTypeOfBool = isTypeOf('boolean');
export const isTypeOfInt = isTypeOf('number');
export const isTypeOfStr = isTypeOf('string');
export const isObject = (x: unknown) => x instanceof Object && x.constructor === Object;
export const isArray = (x: unknown) => Array.isArray(x);
export const isUndefined = (x: unknown) => x === undefined;
export const isNull = (x: unknown) => x === null;
export const isUndefinedOrNull = (x: unknown) => isUndefined(x) || isNull(x);
